import { useGlobalSearchParams } from "expo-router";

// Use only for screens that are currently focused
export function useStandaloneBookingFlow() {
  const { clinicId, isNewUser } = useGlobalSearchParams<{
    clinicId: string;
    isNewUser: string;
  }>();

  const isStandAloneBookingFlow = clinicId !== undefined;
  const newUser = isNewUser === "1";

  return { isStandAloneBookingFlow, clinicId: clinicId, isNewUser: newUser };
}
